module.exports = __webpack_public_path__ + "static/media/icon_site_blue.db807c49.svg";